import Button from "./Components/Button/Button";
import { useTranslation } from "react-i18next";

export function PageError({ error }: { error: Error }) {
  const { t } = useTranslation();
  return (
    <div style={{ padding: 24 }}>
      <h2>{t("somethingWentWrong")}</h2>

      <pre style={{
          marginTop: 16,
          padding: 12,
          background: "#111",
          color: "#f88",
          borderRadius: 6,
          overflow: "auto",
        }}>
        {error.message}
      </pre>
      <Button onClick={() => window.location.reload()}>
        {t("refreshPage")}
      </Button>
      <h3>
        {t("contactAppsmenIfRefreshDoesNotFixProblem")}
      </h3>
    </div>
  );
}
